import { render } from "./EdoDocumentTitleDataSection.vue?vue&type=template&id=51139c7d&scoped=true"
import script from "./EdoDocumentTitleDataSection.vue?vue&type=script&lang=js"
export * from "./EdoDocumentTitleDataSection.vue?vue&type=script&lang=js"

import "./EdoDocumentTitleDataSection.vue?vue&type=style&index=0&id=51139c7d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51139c7d"]])

export default __exports__